import React, {Component, ReactNode} from 'react'
import {AdminPagePropsSet, createAdminPage} from '../../shared/hoc/createAdminPage'
import {AdminReserveLocationState} from './AdminReserveInterfaces'
import {AdminAgentReserveSteps, AdminManagerReserveSteps, AdminReserveStepper} from './AdminReserveStepper'
import {PageFooterArea, PageMainArea} from '../../shared/hoc/withAdminPageTemplate'
import {StyledLink} from '../../../styledComponents/adminPage/Links'
import lsHelper from './AdminReserveLocationStateHelper'
import {AdminReserveDetailsViewProps} from './AdminReserveComponents/ARDetailsView'
import {HeadingAreaMessageParams} from '../../shared/pageBaseComponents/HeadingAreaMessageComponent'
import styled from 'styled-components'
import {Nullable} from '../../../app/TypeHelpers'
import {PaymentInformation} from '../ReserveFacilityModel'
import {ReservationClass} from '../ReservationInterfaces'
import {Box} from '@mui/material';
import {Location} from 'react-router-dom'

interface LocationState extends AdminReserveLocationState {
    initialMessage?: HeadingAreaMessageParams
}

interface Props {
    classification: ReservationClass
    condominiumCd: string
    location: Location<LocationState>
    renderDetailsView: (props: {
        data: AdminReserveDetailsViewProps,
    }) => ReactNode
}

interface State {
    paymentInfo: Nullable<PaymentInformation>
}

class AdminReserveCompletePage extends Component<Props & AdminPagePropsSet, State> {

    private locationState: AdminReserveLocationState
    private hasOptions: boolean

    constructor(props: Readonly<Props & AdminPagePropsSet>) {
        super(props)

        if (!this.props.location || !this.props.location.state || !this.props.location.state.reservationInfo) {
            throw Error('前画面からの引き継ぎ情報がありません。画面遷移が不正です。')
        }
        const {initialMessage, previousPageUrl, previousPageName, ...rest} = this.props.location.state
        this.locationState = lsHelper.fromObject(rest)

        if (this.props.classification !== this.locationState.reservationInfo.classification) {
            throw Error('渡された予約情報が画面と合っていません。画面遷移が不正です。')
        }

        if (this.locationState.facilityData === null) {
            throw Error('施設情報がありません。画面遷移が不正です。')
        }
        this.hasOptions = this.locationState.facilityData.facilityOptions.length > 0

        this.handleClickLink = this.handleClickLink.bind(this)
    }

    componentDidMount(): void {
        this.showInitialMessage()
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state || !this.props.location.state.initialMessage) {
            return
        }
        const {initialMessage, ...rest} = this.props.location.state
        this.props.navigate(
            this.props.location.pathname,
            {
                replace: true,
                state: rest,
            },
        )
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    handleClickLink(): void {
        const classificationString = this.props.classification
        this.props.navigate(
            `/admin/condominiums/${this.props.condominiumCd}/${classificationString}-reserve/select-facility`,
            {replace: true},
        )
    }

    render(): ReactNode {
        return (<>
            {
                this.props.classification === ReservationClass.AGENT
                    ? <Box height={'108px'} bgcolor={'#ffffff'} padding={'24px'}>
                        <AdminReserveStepper
                        classification={ReservationClass.AGENT}
                        step={AdminAgentReserveSteps.COMPLETE}
                        hasOption={this.hasOptions}
                    />
                    </Box>
                    : <Box height={'108px'} bgcolor={'#ffffff'} padding={'24px'}>
                        <AdminReserveStepper
                        classification={ReservationClass.MANAGER}
                        step={AdminManagerReserveSteps.COMPLETE}
                        hasOption={this.hasOptions}
                    />
                    </Box>
            }
            <PageMainArea>
                {
                    this.props.renderDetailsView({
                        data: {
                            type: 'complete',
                            locationState: this.locationState,
                            hasOptions: this.hasOptions,
                        },
                    })
                }
            </PageMainArea>
            <PageFooterArea>
                <CenteringContainer>
                    <StyledLink onClick={this.handleClickLink}>
                        {
                            (this.props.classification === ReservationClass.AGENT)
                                ? '代行予約TOPに戻る'
                                : '管理者予約TOPに戻る'
                        }
                    </StyledLink>
                </CenteringContainer>
            </PageFooterArea>
        </>)
    }
}

export default createAdminPage(AdminReserveCompletePage)

const CenteringContainer = styled.div`
  margin-right: auto;
  margin-left: auto;
`
